import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconLanguage } from "@tabler/icons-react";

export default function LangFilter({
  selected,
  setSelected,
  customData,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  customData?: Item[];
}) {
  let data: Item[] = [];
  if (customData) {
    data = customData;
  } else {
    data.push({ key: "en", value: "English" });
    data.push({ key: "ja", value: "Japanese" });
  }

  return (
    <GenericFilter
      classNames={"w-[120px]"}
      selected={selected}
      setSelected={setSelected}
      startContent={<IconLanguage height={30} width={30} />}
      label="Lang"
      selectionMode="single"
      data={data}
    />
  );
}
